<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
        	<div class="col-md-2">
            <smallBar></smallBar>
          </div>
          <div class="col-md-10">
            <FinanceBox :use_filter=true ></FinanceBox>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import FinanceBox from './FinanceBox'
import smallBar from './SmallBar.vue';

export default {
  name: 'finance_box',
  data() {
    return {
      
    }
  },
  created() {
    
  },
  components: {
    FinanceBox,smallBar
  },
  props: ['toggle_aside'],
  methods: {
    
  }
}
</script>


// WEBPACK FOOTER //
// FinanceList.vue?18c891ad